import React, { useState, useEffect } from 'react';
import Loading from '../components/loading/Loading'
import { Link, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import axios from 'axios';
import Swal from 'sweetalert2';

import UserModal from '../components/modal/UserModal'
import { format } from 'date-fns';
import {
    Typography, TablePagination,
    Table, TableBody, TableCell,
    TableHead, TableRow, TableContainer,
} from "@mui/material";
export default function UsersView() {
    const navigate = useNavigate();
    const userUID = useSelector(state => state.user.uid);
    const [garage, setGarage] = useState()
    const [usertype, setUsertype] = useState('')
    const [showDiv, setShowDiv] = useState(false);
    const [loading, setLoading] = useState(true);
    const [loadingText, setLoadingText] = useState('Loading Users, Please Wait...')

    useEffect(() => {
        if (userUID !== 'none') {
            GetAllUsers('');
        }

        const timer = setTimeout(() => {
            setShowDiv(true);
        }, 1200);
    }, [userUID]);

    function resetGarageData() {
        setGarage([]);
    }


    function GetAllUsers(usertype) {
        setLoading(true);
        setGarage([])
        axios.post(`${process.env.REACT_APP_API_URL}`, { action: 'GetAllUsers', id: userUID, usertype: usertype })
            .then(response => {
                setGarage(response.data.data);
                console.log("response", response.data.data)
                setLoading(false);
            })
            .catch(error => {
                setLoading(false);
                console.error('Error fetching data:', error);
            });
    }


    return (
        <section className="page-content sec-padding">
            <div className="container-fluid">
                <div className="page-content-details">
                    <div className="sec-title row">
                        <div className="col-md-6 text-start">
                            <h3>Users</h3>
                        </div>
                        <div className="col-md-6 text-end">
                            <button
                                onClick={() => {
                                    setUsertype('');
                                    GetAllUsers('');
                                }}
                                className={(usertype === '' || usertype === null) ? 'btn btn-primary me-2' : 'btn btn-seconary me-2'}>None</button>
                            <button
                                onClick={() => {
                                    setUsertype('Tenant');
                                    GetAllUsers('Tenant');
                                }}
                                className={usertype === 'Tenant' ? 'btn btn-primary me-2' : 'btn btn-seconary me-2'}>Tenant</button>
                            <button
                                onClick={() => {
                                    setUsertype('Owner');
                                    GetAllUsers('Owner');
                                }}
                                className={usertype === 'Owner' ? 'btn btn-primary' : 'btn btn-seconary'}>Owner</button>
                        </div>
                    </div>
                    <div className='row'>
                        {garage && garage.length > 0 ?
                            <TableContainer
                                className='table'
                                sx={{
                                    width: {
                                        xs: "274px",
                                        sm: "100%",
                                    },
                                }}
                            >
                                <Table
                                    aria-label="simple table"
                                    sx={{
                                        whiteSpace: "nowrap",
                                        mt: 2,
                                    }}
                                >
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>
                                                <Typography color="textSecondary" variant="h6">Name</Typography>
                                            </TableCell>
                                            <TableCell>
                                                <Typography color="textSecondary" variant="h6">Email</Typography>
                                            </TableCell>
                                            <TableCell>
                                                <Typography color="textSecondary" variant="h6">Phone</Typography>
                                            </TableCell>
                                            <TableCell>
                                                <Typography color="textSecondary" variant="h6">Stripe Details</Typography>
                                            </TableCell>
                                            <TableCell>
                                                <Typography color="textSecondary" variant="h6">Account Type</Typography>
                                            </TableCell>
                                            <TableCell>
                                                <Typography color="textSecondary" variant="h6">View</Typography>
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {garage.map((element, index) => (
                                            <TableRow key={index}>

                                                <TableCell>
                                                    <Typography color="textSecondary" variant="h6">{element.firstname ? element.firstname : ''} {element.lastname ? element.lastname : ''}</Typography>
                                                </TableCell>

                                                <TableCell>
                                                    <Typography color="textSecondary" variant="h6">{element.email ? element.email : ''}</Typography>
                                                </TableCell>

                                                <TableCell>
                                                    <Typography color="textSecondary" variant="h6">{element.phoneNumber ? element.phoneNumber : ''}</Typography>
                                                </TableCell>
                                                <TableCell>
                                                    <Typography color="textSecondary" variant="h6">
                                                        <span className={element.stripe_verified === '1' ? 'text-info' : 'text-danger'}>
                                                            {element.stripeEmail ? element.stripeEmail : ''}<br />
                                                            {element.stripe_id ? element.stripe_id : ''}
                                                        </span>
                                                    </Typography>
                                                </TableCell>

                                                <TableCell>
                                                    <Typography color="textSecondary" variant="h6">
                                                        {element.userType ? element.userType : ''}
                                                    </Typography>
                                                </TableCell>
                                                <TableCell>
                                                    <Typography color="textSecondary" variant="h6">
                                                        <UserModal elements={element} />
                                                    </Typography>
                                                </TableCell>


                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer >
                            :

                            loading ?
                                <Loading text={loadingText} />
                                :
                                <div className='typewriter '>No Users yet</div>
                        }
                    </div>
                </div>
            </div>
        </section >
    );
}